import { TabOptions } from '../../interfaces/tab-option.interface';
import { TabControl } from './tab-control.model';

export class EntityTypeAttributeTabControl extends TabControl {

  entityId: number;
  entityTypeId: number;

  constructor(options: TabOptions, entityTypeId: number) {
    super(options);

    this.className = "EntityTypeAttributeTabControl";
    this.entityTypeId = entityTypeId;
  }

}
